import React from 'react';
import Icon from '../Icon';
import { COMPANY_MAIL, COMPANY_MOBILE } from '../../constants/defaultTypes';
import './style.css';

const CallToAction = () => {
  return (
    <div id="alienbrains-call-to-action" className="call-to-action-container">
      <a href={`tel:${COMPANY_MOBILE}`} className="action-link">
        Call Us <Icon name="fas fa-mobile" className="action-link-icon" />{' '}
      </a>
      <a href={`mailto:${COMPANY_MAIL}`} className="action-link">
        Mail us <Icon name="fas fa-envelope" className="action-link-icon" />
      </a>
    </div>
  );
};

export default CallToAction;



// WEBPACK FOOTER //
// ./src/Components/CallToAction/index.js